import fetchRequest from "./fetchRequest";

function parseJson(json) {
  try {
    return JSON.parse(json);
  } catch (err) {
    return err.message;
  }
} 

export const postMessage = async (messageData) => {
  const postMessageURL = `${window.location.origin}/api/emc/send_unauth_message`;

  try {
    const resp = await fetchRequest(
      postMessageURL,
      {
        method: "POST",
        body: JSON.stringify(messageData),
        headers: {
          "Content-Type": "application/json"
        },
      }
    );

    if (!resp.ok) {
      const errorText = await resp
        .text()
        .catch(err => new Error(`Status ${resp.status} ${resp.statusText}: Invalid response.`));

      if (errorText.message) {
        throw {
          response: {
            data: errorText.message
          }
        };
      } else if (errorText.includes("code")) {
        throw {
          response: {
            data: parseJson(errorText)
          }
        };
      }

      throw {
        response: {
          data: "Invalid Respnse Error"
        }
      };
    }  

    const postMessagePromise = await resp.json();

    return { data: postMessagePromise };
  } catch (error) {
    console.log(error, "postmessage");
    return Promise.reject(error);
  }
};
